module.exports = __webpack_public_path__ + "media/images/new_landing/people/josef-matejka-c616795744cd2ee9d0d80ae330b1290c.jpg";